import { Timestamp } from "@firebase/firestore";
import { PlacementType } from ".";

/**
 * Firestore notices 컬렉션의 Notice 문서 인터페이스
 */
export interface Notice {
  noticeId: string;
  title: string;
  uploadType: 'zip' | 'url';
  content: string | null; // HTML 내용이 포함될 수 있으므로 string 타입으로 정의
  bannerImageUrl: string | null;
  isPublic: boolean;
  placement: PlacementType | null;
  order: number | null;
  isPopup: boolean;
  allowedUsers: string[] | null; // isPublic이 false일 때만 사용
  allowedEnterprises: string[] | null; // isPublic이 false일 때만 사용
  createdAt: Timestamp;
}

/**
 * Notice 컬렉션 경로 상수
 */
export const NOTICE_COLLECTION = process.env.REACT_APP_NOTICE_COLLECTION as string;